import React from 'react';
import { string, func, object, bool, arrayOf, shape, array } from 'prop-types';
import Wrapper from '../Wrapper';
import RadioButton from './RadioButton';

const radioDefaultStyles = {
  padding: '8px 0',
  marginTop: '8px',
  marginLeft: '9px',
};

const RadioGroup = ({
  selectedId,
  onChange,
  isVertical,
  options,
  radioButtonStyles,
  itemCustomStyles,
  textColor,
  isPaymentOptions,
  isTextBold,
  isMoveEnabled,
}) => {
  const radioItemStyles = { ...radioDefaultStyles, ...radioButtonStyles };
  return (
    <Wrapper
      display="flex"
      className="radio-group"
      flexDirection={isVertical ? 'column' : 'row'}
    >
      {options.map((item, index) => (
        <Wrapper
          key={item.id}
          {...radioItemStyles}
          {...itemCustomStyles[index]}
          marginLeft="0px"
          borderColor={
            isPaymentOptions && selectedId === item.id
              ? 'secondaryDarker'
              : 'greyLight'
          }
          backgroundColor={
            isPaymentOptions && selectedId === item.id
              ? 'secondaryLighter'
              : 'primaryWhite'
          }
        >
          <RadioButton
            id={item.id}
            isVertical={isVertical}
            isSelected={selectedId === item.id}
            text={item.text}
            onChange={id => {
              onChange(item);
            }}
            textColor={textColor}
            subText={item.subText}
            isTextBold={isTextBold}
            isMoveEnabled={isMoveEnabled}
          />
        </Wrapper>
      ))}
    </Wrapper>
  );
};

RadioGroup.propTypes = {
  selectedId: string,
  onChange: func,
  isVertical: bool,
  radioButtonStyles: object,
  textColor: string,
  options: arrayOf(
    shape({
      id: string,
      text: string,
    })
  ),
  itemCustomStyles: array,
  isPaymentOptions: bool,
  isTextBold: bool,
  isMoveEnabled: bool,
};

RadioGroup.defaultProps = {
  isSelected: false,
  onChange: () => {},
  selectedId: '',
  options: [],
  isVertical: false,
  itemCustomStyles: [],
  isPaymentOptions: false,
  isTextBold: false,
  isMoveEnabled: false,
};

export default RadioGroup;
